import { Component, OnInit, ViewChild } from "@angular/core";
import * as dayjs from "dayjs";
import * as FileSaver from "file-saver";
import { NgxSpinnerService } from "ngx-spinner";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { Condition } from "src/app/models/custom-types";
import { ActaDTO } from "src/app/models/dto/acta.dto";
import { FilterEvent } from "src/app/models/filter";
import { ListAction } from "src/app/models/list-actions.model";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { LayoutsService } from "src/app/services/layouts.service";
import { Filter } from "src/app/shared/classes/filter";
import { OperadoresService } from "../../workers/operadores/operadores.service";
import { RevisionPercancesForm } from "./form/form.component";
import { RevisionPercancesService } from "./revision.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-revision",
  templateUrl: "./revision.component.html",
  styleUrls: [],
})
export class RevisionPercancesComponent implements OnInit {
  columnId: string = "IdEmpresa";
  public columns: ListColumn[] = [
    {
      name: "Folio",
      property: "Folio",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Fecha",
      property: "FechaCreadoDisplay",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Descripcion (Corto)",
      property: "DescripcionShort",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Unidad",
      property: "Unidad",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Chofer",
      property: "Nombre",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Era asignado?",
      property: "EsChoferAsignadoDisplay",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public actions: ListAction<ActaDTO>[] = [
    {
      desc: "Ver",
      action: "update",
      visible: () => true,
    },
  ];

  filtro: string = "";
  realdata: any[];
  list: any[];
  listUnidades: any[];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;

  @ViewChild(RevisionPercancesForm, { static: true })
  public formulario: RevisionPercancesForm;
  constructor(
    public service: RevisionPercancesService,
    public opeServ: OperadoresService,
    public layoutService: LayoutsService,
    public spinner: NgxSpinnerService,
    public alerts: AlertasSwalService,
  ) {}
  ngOnInit(): void {
    this.loadRecords();
    this.filter = new Filter<any>(this.conditions, this.columns, true);
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData: any[]) => {
        this.realdata = resultData.map((m) => {
          var DescripcionShort = truncateString(m.Descripcion, 50);
          var EsChoferAsignadoDisplay = m.EsChoferAsignado ? "✅" : "❌";
          var FechaCreadoDisplay = m.FechaCreado
            ? dayjs(m.FechaCreado).format("DD/MM/YYYY hh:mm a")
            : "";
          return {
            ...m,
            EsChoferAsignadoDisplay,
            DescripcionShort,
            FechaCreadoDisplay,
          };
        });
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
    this.service.getTrabajadores().subscribe(
      (resultData) => {
        this.list = resultData;
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
    this.service.getUnidadesEnRuta().subscribe(
      (resultData) => {
        this.listUnidades = resultData;
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  //#region Filter
  public filter: Filter<any>;
  public conditions: Condition<any> = {
    Unidad: (o, f) => o.Unidad.toLocaleLowerCase().indexOf(f) > -1,
    DescripcionShort: (o, f) =>
      o.Descripcion.toLocaleLowerCase().indexOf(f) > -1,
    Nombre: (o, f) => o.Nombre.toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter

  actionstable(e: { action: string; row: any }) {
    if (e.action == "update") {
      this.formulario.setUpdate(e.row);
    }
  }

  saveForm(e: { mode: string; value: any; type: number }) {
    if (e.mode == "create") {
      this.guardar(e.value);
    }
  }
  guardar(row: any) {
    this.service.add(row).subscribe(
      async (next) => {
        const countGood = await this.retryUploadPhotos(next.asm, row.files);
        const mensajeEvidencias = `Se guardaron ${countGood} evidencias de ${row.files.length} enviadas.`;

        this.alerts.correcta(
          "Acta administrativa creada",
          "Folio " + next.folio + " " + mensajeEvidencias,
        );
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }
  private async retryUploadPhotos(asm: string, files: any[]): Promise<number> {
    let countGood = 0;
    let filesToTry = files.slice();

    // eslint-disable-next-line no-constant-condition
    while (true) {
      const newFailed: any[] = [];
      for (const file of filesToTry) {
        try {
          await this.service.addPhoto(asm, file).toPromise();
          countGood++;
        } catch (error: any) {
          if (error.error.Message === "Fallo a guardar evidencia") {
            newFailed.push(file);
          }
        }
      }

      if (newFailed.length === 0) break;

      const imagesHtml = `
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:12px;">
          ${newFailed
            .map(
              (file) => `
            <div style="aspect-ratio:1;overflow:hidden;border-radius:6px;border:1px solid #e2e8f0;">
              <img src="${URL.createObjectURL(file)}"
                style="width:100%;height:100%;object-fit:cover;display:block;" />
            </div>
          `,
            )
            .join("")}
        </div>`;

      const result = await Swal.fire({
        title: "Evidencias fallidas",
        html: `Las siguientes evidencias fallaron al subir:<br>${imagesHtml}`,
        showCancelButton: true,
        confirmButtonText: "Reintentar",
        cancelButtonText: "Continuar",
      });

      if (!result.isConfirmed) break;
      filesToTry = newFailed;
    }

    return countGood;
  }
  downLoad(e, folio) {
    this.spinner.show();
    this.service.getPdf(e).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(
          response.body,
          contentType,
          "acta_administrativa_" + folio + ".pdf",
        );
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      },
    );
  }
  downLoadFile(data: any, contentType: string, filename: string) {
    let blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
    this.spinner.hide();
  }
}
function truncateString(str: string, maxLength: number): string {
  if (str.length > maxLength) {
    return str.slice(0, maxLength) + "...";
  }
  return str;
}
